export default "__VITE_ASSET__PeOt9j_a__"